module.exports = __webpack_public_path__ + "img/4.dee6b07f.png";